import { useState } from 'react';
import { LuCode } from 'react-icons/lu';
import useParseHtml from '../../api/useParseHtml';
import type { ContentEntry } from './AdminContentEntryList';

type ParsedResult = {
  job_content: ContentEntry[];
  agent_content: ContentEntry[];
  title: string | null;
  company_name: string | null;
};

type AdminHtmlParseAreaProps = {
  importRequestId: number;
  onParsed: (result: ParsedResult) => void;
};

export default function AdminHtmlParseArea({ importRequestId, onParsed }: AdminHtmlParseAreaProps) {
  const [html, setHtml] = useState('');
  const { mutate: parseHtml, isPending, error } = useParseHtml();

  const handleParse = () => {
    const trimmed = html.trim();
    if (!trimmed) return;

    parseHtml(
      { importRequestId, html: trimmed },
      {
        onSuccess: (data) => {
          onParsed({
            job_content: data.job_content.map((item) => ({
              label: item.label,
              content: item.content,
            })),
            agent_content: data.agent_content.map((item) => ({
              label: item.label,
              content: item.content,
            })),
            title: data.title,
            company_name: data.company_name,
          });
          setHtml('');
        },
      }
    );
  };

  return (
    <div className="min-w-0 rounded-lg border border-dashed border-gray-300 bg-gray-50 p-3">
      <div className="mb-2 flex items-center gap-1.5">
        <LuCode className="size-4 text-sub" />
        <span className="text-sm font-medium text-main">HTMLからパース</span>
      </div>
      <textarea
        value={html}
        onChange={(e) => setHtml(e.target.value)}
        placeholder="求人ページのHTMLを貼り付けてください（DevToolsからコピーしたHTML）"
        rows={4}
        className="box-border w-full max-w-full min-w-0 resize-y rounded border border-solid border-border bg-white px-2 py-1.5 font-mono text-xs text-main"
      />
      {error && (
        <p className="mt-1 text-xs text-red-500">
          {error instanceof Error ? error.message : 'パースに失敗しました'}
        </p>
      )}
      <button
        type="button"
        onClick={handleParse}
        disabled={isPending || !html.trim()}
        className="mt-2 rounded border-0 bg-primary px-3 py-1.5 text-sm text-white hover:opacity-90 disabled:opacity-50"
      >
        {isPending ? 'パース中...' : 'HTMLからパース'}
      </button>
    </div>
  );
}
